import React, { FC } from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
import { makeStyles } from "@material-ui/core/styles";

import styles from "./cardFooterStyle";

interface IProps {
  className: string;
  color?: "warning" | "success" | "danger" | "info" | "primary" | "rose";
  plain?: boolean;
  stats: boolean;
  profile?: boolean;
  chart?: boolean;
}
// @ts-ignore
const useStyles = makeStyles(styles);

export const CardFooter: FC<IProps> = props => {
  const classes = useStyles();
  const { className, children, plain, profile, stats, chart, ...rest } = props;
  const cardFooterClasses = classNames({
    [classes.cardFooter]: true,
    [classes.cardFooterPlain]: plain,
    [classes.cardFooterProfile]: profile,
    [classes.cardFooterStats]: stats,
    [classes.cardFooterChart]: chart,
    [className]: className !== undefined
  });
  return (
    <div className={cardFooterClasses} {...rest}>
      {children}
    </div>
  );
};
